// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickerList__container-fc3e11 {
  height: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-inline-start: 12px;
  padding-inline-end: 0px;
  display: grid;
  grid-template-columns: repeat(4, 88px);
  grid-template-rows: repeat(auto-fill, 88px);
  gap: 8px 8px;
  align-items: start;
  flex: 1;
  overflow-y: auto;
  user-select: none;
}

.StickerList__no-results-f90258 {
  height: 100%;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.StickerList__sticker-dcecc4 {
  width: 100%;
  height: 100%;
  font-size: 0;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/StickerPanel/StickerList/StickerList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,aAAA;EACA,sCAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  height: 100%;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-inline-start: 12px;\n  padding-inline-end: 0px;\n  display: grid;\n  grid-template-columns: repeat(4, 88px);\n  grid-template-rows: repeat(auto-fill, 88px);\n  gap: 8px 8px;\n  align-items: start;\n  flex: 1;\n  overflow-y: auto;\n  user-select: none;\n}\n\n.no-results {\n  height: 100%;\n  padding: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.sticker {\n  width: 100%;\n  height: 100%;\n  font-size: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StickerList__container-fc3e11`,
	"no-results": `StickerList__no-results-f90258`,
	"noResults": `StickerList__no-results-f90258`,
	"sticker": `StickerList__sticker-dcecc4`
};
module.exports = ___CSS_LOADER_EXPORT___;
